import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function LongevityText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Genetic" 
            headline_grey = "Longevity Report -"
            headline_p2 = "Personalized Signatures"

            text1 = "This report provides insights into how your genetic makeup influences your potential lifespan, aging process, and overall health as you age."
            text2 = "This analysis is based on genetic variants that are linked to longevity, aging-related diseases, and the body's ability to repair, regenerate, and protect itself from environmental stressors over time"
            text3 = "It may help optimize your health and increase your chances of living a longer, healthier life."

            />
    }/>
            
  )
}